import React, {
  createContext,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react';

const WebSocketContext = createContext(null);

export const WebSocketProvider = ({ children }) => {
  const [brand, setBrand] = useState(null);
  const [pid, setPid] = useState(null);
  const [messages, setMessages] = useState();
  const ws = useRef(null);
  const [isWebSocketOpen, setIsWebSocketOpen] = useState(false);

  useEffect(() => {
    //AWS WS URL for demand partner publish Status

    const url = `${process.env.REACT_APP_WS_PUBLISH_STATUS_URL}`;
    ws.current = new WebSocket(url); //Creating a new websocket connection

    ws.current.onopen = () => {
      console.info('WebSocket connection opened');
      setIsWebSocketOpen(true); // Set flag to indicate WebSocket is open
      if (isWebSocketOpen && brand && pid) {
        ws.current.send(
          //Below is the structure of payload which needs to be sent to get subscribed to the ws connection
          JSON.stringify({ action: 'subscribe', data: `${brand}|${pid}` })
        );
      }
    };

    ws.current.onmessage = event => {
      if (event.data !== 'Subscribed') {
        //Check if data is 'Subscribed' or not as string can't be parsed under JSON.parse
        const data = JSON.parse(event.data);
        setMessages(data);
      } else {
        console.log(event.data);
      }
    };

    ws.current.onclose = () => {
      console.log('WebSocket connection closed');
      // location.reload();
    };

    ws.current.onerror = error => {
      console.error('WebSocket error:', error);
    };
  }, []);

  //Here we are checking if the connection is already open and if brand and pid gets changed,
  // then send a new message to get subscribed to the new brand and pid

  useEffect(() => {
    if (
      isWebSocketOpen &&
      ws.current &&
      ws.current.readyState === WebSocket.OPEN &&
      brand &&
      pid
    ) {
      ws.current.send(
        JSON.stringify({ action: 'subscribe', data: `${brand}|${pid}` })
      );
    }
  }, [isWebSocketOpen, brand, pid]);

  return (
    <WebSocketContext.Provider value={{ messages, setBrand, setPid }}>
      {children}
    </WebSocketContext.Provider>
  );
};

export const useWebSocketContext = () => useContext(WebSocketContext);
export default WebSocketProvider;
